import { Fragment, useState } from 'react';
import Classes from '../../draftOrdersNew/css/draftOrderDetailPage.module.css';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import UpdateShipmentDetails from './updateShipmentDetails';

const Aside = (props) => {

    const {
        draftOrder,
        notes,
        deliveryRemark,
        setUpdateToggle
    } = props;

    const [updateShipmentDetail, setUpdateShipmentDetail] = useState(false);

    const formatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-IN');
        }
    }

    

    function checkNullValues(obj, text) {
        try {
            for (const key in obj) {
                if (
                    key !== "createdAt" &&
                    key !== "updatedAt" &&
                    key !== "purchaseOrderId" &&
                    key !== `po${text}DetailId`
                ) {
                    if (obj[key] !== null) {
                        return true;
                    }
                }
            }
            return false;
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <Fragment>
            <div
                className={[
                    Classes.Box,
                    'box'
                ].join(' ')}
            >
                {draftOrder.length !== 0 && (
                    <div>
                        {draftOrder?.PoVendorDetails.length !== 0 && (
                            <div>
                                <div>
                                    <div style={{ borderBottom: '1px solid #DBDDE0' }}>
                                        <div className={Classes.containerBox}>
                                            <div className={Classes.asideCustomer}>
                                                <h6 style={{ margin: 'auto 0px' }}>
                                                    Vendor
                                                </h6>
                                            </div>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        color: '#2c6ecb',
                                                        display: 'flex',
                                                        flexDirection: 'column'
                                                    }}
                                                >
                                                    <p style={{ marginRight: '5px' }}>
                                                        {draftOrder?.PoVendorDetails[0]?.vendorName}
                                                    </p>
                                                    <p>GST - {draftOrder?.PoVendorDetails[0]?.vendorGstNumber}</p>
                                                    <p>{draftOrder?.PoVendorDetails[0]?.vendorCode}</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ borderBottom: '1px solid #DBDDE0' }}>
                                        {checkNullValues(draftOrder.PoVendorContactDetails, "VendorContact") !== false && (
                                            <div className={Classes.containerBox}>
                                                <div className='mb-3'>
                                                    <p className={Classes.asideHeaders}>
                                                        CONTACT INFORMATION
                                                    </p>
                                                </div>
                                                {draftOrder?.PoVendorContactDetails !== null && (
                                                    <div
                                                        style={{
                                                            color: '#2c6ecb',
                                                            fontSize: '14px'
                                                        }}
                                                    >
                                                        <p>{`${draftOrder?.PoVendorContactDetails?.firstName} ${draftOrder?.PoVendorContactDetails?.lastName || ""}`}</p>
                                                        <p>{draftOrder?.PoVendorContactDetails?.role}</p>
                                                        <p>{draftOrder?.PoVendorContactDetails?.email}</p>
                                                        <p>{draftOrder?.PoVendorContactDetails?.phoneNumber}</p>

                                                        {/* <p style={{ marginTop: '5px' }}>
                                        </p> */}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {draftOrder?.PoVendorDetails !== null && (
                                    <div>
                                        <div>
                                            {draftOrder?.PoVendorDetails.length !== 0 ? (
                                                <div>
                                                    {draftOrder?.PoVendorDetails.map((vendor, index) => (
                                                        <div style={{ borderBottom: '1px solid #DBDDE0' }}>
                                                            <div className={Classes.containerBox}>
                                                                <div>
                                                                    <div className='mb-3'>
                                                                        <p className={Classes.asideHeaders}>{vendor.addressType === "Shipping" ? "PICKUP" : "BILLING" } ADDRESS</p>
                                                                    </div>

                                                                    <div key={index} style={{ fontSize: '14px' }}>
                                                                        <div style={{ display: 'flex' }}>
                                                                            <p style={{ marginRight: '5px' }}>{vendor?.firstName}</p>
                                                                            <p>{vendor?.lastName || ""}</p>
                                                                        </div>

                                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                            <p style={{ marginRight: '5px' }}>{vendor?.addressLine1}</p>
                                                                            {vendor?.addressLine2 !== null ? (
                                                                                <p>{vendor?.addressLine2}</p>
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                        </div>

                                                                        <div style={{ display: 'flex' }}>
                                                                            <p style={{ marginRight: '5px' }}>{vendor?.pincode}</p>
                                                                            <p>{vendor?.city},</p>
                                                                        </div>

                                                                        <div>
                                                                            <p>{vendor?.state?.toTitleCase()},</p>
                                                                        </div>

                                                                        <div>
                                                                            <p>{vendor?.phoneNumber}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : null}

                                        </div>

                                    </div>
                                )}

                            </div>
                        )}
                    </div>
                )}
            </div>
            <div
                className={[
                    Classes.Box,
                    'box'
                ].join(' ')}
            >
                {draftOrder.length !== 0 && (
                    <div>
                        {draftOrder?.PoLocationDetails.length !== 0 && (
                            <div>
                                <div>
                                    <div style={{ borderBottom: '1px solid #DBDDE0' }}>
                                        <div className={Classes.containerBox}>
                                            <div className={Classes.asideCustomer}>
                                                <h6 style={{ margin: 'auto 0px' }}>
                                                    Location
                                                </h6>
                                            </div>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        color: '#2c6ecb',
                                                        display: 'flex',
                                                        flexDirection: 'column'
                                                    }}
                                                >
                                                    <p style={{ marginRight: '5px' }}>
                                                        {draftOrder?.PoLocationDetails[0]?.locationName}
                                                    </p>
                                                    <p>GST - {draftOrder?.PoLocationDetails[0]?.locationGstNumber}</p>
                                                    <p>{draftOrder?.PoLocationDetails[0]?.locationCode}</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ borderBottom: '1px solid #DBDDE0' }}>
                                        {checkNullValues(draftOrder.PoLocationContactDetails, "LocationContact") !== false && (
                                            <div className={Classes.containerBox}>
                                                <div className='mb-3'>
                                                    <p className={Classes.asideHeaders}>
                                                        CONTACT INFORMATION
                                                    </p>
                                                </div>

                                                {draftOrder?.PoLocationContactDetails !== null && (
                                                    <div
                                                        style={{
                                                            color: '#2c6ecb',
                                                            fontSize: '14px'
                                                        }}
                                                    >
                                                        <p>{`${draftOrder?.PoLocationContactDetails?.firstName} ${draftOrder?.PoLocationContactDetails?.lastName || ""}`}</p>
                                                        <p>{draftOrder?.PoLocationContactDetails?.role}</p>
                                                        <p>{draftOrder?.PoLocationContactDetails?.email}</p>
                                                        <p>{draftOrder?.PoLocationContactDetails?.phoneNumber}</p>

                                                        {/* <p style={{ marginTop: '5px' }}>
                                        </p> */}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>


                                <div>
                                    {draftOrder?.PoLocationDetails.length !== 0 ? (
                                        <div>
                                            {draftOrder?.PoLocationDetails.map((location, index) => (
                                                <div style={{ borderBottom: '1px solid #DBDDE0' }}>
                                                    <div className={Classes.containerBox}>
                                                        <div>
                                                            <div className='mb-3' style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                gap: '1rem'
                                                            }}>
                                                                <p className={Classes.asideHeaders}>{location.addressType?.toUpperCase()} ADDRESS</p>
                                                            </div>

                                                            <div key={index} style={{ fontSize: '14px' }}>
                                                                <div style={{ display: 'flex' }}>
                                                                    <p style={{ marginRight: '5px' }}>{location?.firstName}</p>
                                                                    <p>{location?.lastName || ""}</p>
                                                                </div>

                                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                    <p style={{ marginRight: '5px' }}>{location?.addressLine1}</p>
                                                                    {location?.addressLine2 !== null ? (
                                                                        <p>{location?.addressLine2}</p>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </div>

                                                                <div style={{ display: 'flex' }}>
                                                                    <p style={{ marginRight: '5px' }}>{location?.pincode}</p>
                                                                    <p>{location?.city},</p>
                                                                </div>

                                                                <div>
                                                                    <p>{location?.state?.toTitleCase()},</p>
                                                                </div>

                                                                <div>
                                                                    <p>{location?.phoneNumber}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : null}
                                </div>

                            </div>
                        )}
                    </div>
                )}
            </div>

            {draftOrder.length !== 0 && (
                <div className='' >
                    {checkNullValues(draftOrder.PoShipmentDetails, "Shipment") !== false && (
                        <div
                            className={[
                                Classes.Box,
                                Classes.asideMetafields,
                                'box'
                            ].join(' ')}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '1.5rem'
                            }}>
                                <h6 style={{ margin: '5px 0px' }}>
                                    Shipment Details
                                </h6>

                                <p style={{
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    color: '#2c6ecb',
                                    fontWeight: '500'
                                }} onClick={() => {
                                    setUpdateShipmentDetail(true);
                                }}>Edit Shipment Detail</p>
                            </div>
                            <div style={{ display: 'flex', borderBottom: '1px solid #DBDDE0', margin: '12px 0px' }}>
                                <p style={{ fontWeight: '500', marginRight: '7px', fontSize: '14px', width: '50%' }}>
                                    Transporter Name:
                                </p>
                                <p style={{
                                    color: '#2c6ecb',
                                    fontSize: '14px',
                                    width: '50%'

                                }}>
                                    {draftOrder?.PoShipmentDetails?.transporterName}
                                </p>
                            </div>
                            <div style={{ display: 'flex', borderBottom: '1px solid #DBDDE0', margin: '12px 0px' }}>
                                <p style={{ fontWeight: '500', marginRight: '7px', fontSize: '14px', width: '50%' }}>
                                    Transporter Type:
                                </p>
                                <p style={{
                                    color: '#2c6ecb',
                                    fontSize: '14px', width: '50%'
                                }}>
                                    {draftOrder?.PoShipmentDetails?.transporterType}
                                </p>
                            </div>
                            <div style={{ display: 'flex', borderBottom: '1px solid #DBDDE0', margin: '12px 0px' }}>
                                <p style={{ fontWeight: '500', marginRight: '7px', fontSize: '14px', width: '50%' }}>
                                    Estimated Dispatch Date:
                                </p>
                                <p style={{
                                    color: '#2c6ecb',
                                    fontSize: '14px', width: '50%'
                                }}>
                                    {formatDate(draftOrder?.PoShipmentDetails?.estimatedDispatchDate)}
                                </p>
                            </div>
                            <div style={{ display: 'flex', borderBottom: '1px solid #DBDDE0', margin: '12px 0px' }}>
                                <p style={{ fontWeight: '500', marginRight: '7px', fontSize: '14px', width: '50%' }}>
                                    Estimated Delivery Date:
                                </p>
                                <p style={{
                                    color: '#2c6ecb',
                                    fontSize: '14px', width: '50%'
                                }}>
                                    {formatDate(draftOrder?.PoShipmentDetails?.estimatedReceivingDate)}
                                </p>
                            </div>
                            <div style={{ display: 'flex', borderBottom: '1px solid #DBDDE0', margin: '12px 0px' }}>
                                <p style={{ fontWeight: '500', marginRight: '7px', fontSize: '14px', width: '50%' }}>
                                    Freight Charges:
                                </p>
                                <p style={{
                                    color: '#2c6ecb',
                                    fontSize: '14px', width: '50%'
                                }}>
                                    &#8377;{draftOrder?.PoShipmentDetails?.freightCharges}
                                </p>
                            </div>
                            <div style={{ display: 'flex', borderBottom: '1px solid #DBDDE0', margin: '12px 0px' }}>
                                <p style={{ fontWeight: '500', marginRight: '7px', fontSize: '14px', width: '50%' }}>
                                    Bilty Number:
                                </p>
                                <p style={{
                                    color: '#2c6ecb',
                                    fontSize: '14px', width: '50%'
                                }}>
                                    {draftOrder?.PoShipmentDetails?.biltyNumber}
                                </p>
                            </div>
                            <div style={{ display: 'flex', borderBottom: '1px solid #DBDDE0', margin: '12px 0px' }}>
                                <p style={{ fontWeight: '500', marginRight: '7px', fontSize: '14px', width: '50%' }}>
                                    Bilty Date:
                                </p>
                                <p style={{
                                    color: '#2c6ecb',
                                    fontSize: '14px', width: '50%'
                                }}>
                                    {formatDate(draftOrder?.PoShipmentDetails?.biltyDate)}
                                </p>
                            </div>

                        </div>
                    )}
                </div>
            )}

            {deliveryRemark && (
                <div className={Classes.Box} id='deliveryRemark'>
                    <div style={{ padding: '0.8rem 1.1rem' }}>
                        <h6 style={{ margin: 'auto 0px' }}>
                            Delivery Remark
                        </h6>
                        <p className={Classes.remarkBox}>
                            {deliveryRemark}
                        </p>
                    </div>
                </div>
            )}


            {notes && (
                <div className={Classes.Box} id='notes'>
                    <div style={{ padding: '0.8rem 1.1rem' }}>
                        <h6 style={{ margin: 'auto 0px' }}>
                            Notes
                        </h6>
                        <p className={Classes.remarkBox}>
                            {notes}
                        </p>
                    </div>
                </div>
            )}

            {draftOrder?.length !== 0 && (
                <div id=''>
                    {(draftOrder?.PoPaymentDetails?.invoiceUrl?.length !== 0 ||  draftOrder?.PoPaymentDetails?.challanUrl?.length !== 0) && (
                        <div className={Classes.Box} style={{ padding: '10px' }}>
                            <div className='mb-3'>
                                <h6 style={{ margin: 'auto 0px', padding: '6px' }}>
                                    Documents Attached
                                </h6>
                            </div>

                            {draftOrder?.PoPaymentDetails?.invoiceUrl?.length !== 0 && (
                                <div>
                                    <p style={{margin:0,padding:'0px 6px'}}>Invoice</p>
                                    <ul className={["list-group mt-1",Classes.Box].join(' ')}>
                                        {draftOrder?.PoPaymentDetails?.invoiceUrl?.map((fileName, index) => (
                                            <a 
                                                className="list-group-item" 
                                                key={index} 
                                                target='_blank'
                                                href={fileName}
                                                rel="noreferrer"
                                                style={{fontSize:13}}
                                            >
                                                <InsertDriveFileIcon style={{fontSize:'20px',marginRight:'5px'}}/>
                                                {decodeURIComponent(fileName.substring(fileName.lastIndexOf('/') + 1, fileName.lastIndexOf('?')))}
                                            </a>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {draftOrder?.PoPaymentDetails?.challanUrl?.length !== 0 && (
                                <div style={{marginTop:10}}>
                                    <p style={{margin:0,padding:'0px 6px'}}>Challan</p>
                                    <ul className={["list-group mt-1",Classes.Box].join(' ')}>
                                        {draftOrder?.PoPaymentDetails?.challanUrl?.map((fileName, index) => (
                                            <a 
                                                className="list-group-item" 
                                                key={index} 
                                                target='_blank'
                                                href={fileName}
                                                rel="noreferrer"
                                                style={{fontSize:13}}
                                            >
                                                <InsertDriveFileIcon style={{fontSize:'20px',marginRight:'5px'}}/>
                                                {decodeURIComponent(fileName.substring(fileName.lastIndexOf('/') + 1, fileName.lastIndexOf('?')))}
                                            </a>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}

            {draftOrder ? 
                <UpdateShipmentDetails updateShipmentDetail={updateShipmentDetail} draftOrder={draftOrder} setUpdateToggle={setUpdateToggle} setUpdateShipmentDetail={setUpdateShipmentDetail} />
            : null}
        </Fragment>
    )
};

export default Aside;
